<template>
    <v-data-table
        hide-default-header
        v-bind="$attrs"
        v-on="$listeners"
        :options="tableOptions">
        <template
            v-for="(_, slot) of $scopedSlots"
            v-slot:[slot]="scope">
            <slot
                :name="slot"
                v-bind="scope"/>
        </template>

        <template v-slot:header="{props}">
            <thead
                class="v-data-table-header">
                <tr>
                    <th
                        v-for="(header, index) in props.headers"
                        :key="index"
                        :class="getHeaderClass(header)"
                        :style="getHeaderStyle(header)"
                        @click="onHeaderClick(header)">
                        {{ header.text }}
                        <icon
                            v-if="!disableSort && header.sortable !== false"
                            class="ml-3 sort-icon"
                            size="8px"
                            :value="getSortIcon(header)"/>
                    </th>
                </tr>
            </thead>
        </template>
    </v-data-table>
</template>

<script>
export default {
    name: 'BaseTable',

    props: {
        disableSort: {
            type: Boolean,
            default: false
        },

        preventDefault: {
            type: Boolean,
            default: false
        }
    },

    data () {
        return {
            sortBy: null,
            sortType: null
        }
    },

    computed: {
        tableOptions () {
            const options = {}
            if (this.sortBy && !this.preventDefault) {
                options.sortBy = [this.sortBy]
                options.sortDesc = [this.sortType === 'DESC']
            }

            return {
                ...options,
                ...this.$attrs.options
            }
        }
    },

    methods: {
        onHeaderClick (header) {
            if (this.disableSort && !header.sortable) {
                return
            }
            if (header.value !== this.sortBy) {
                this.sortBy = header.value
                this.sortType = 'ASC'
            } else {
                if (this.sortType === 'DESC') {
                    this.sortBy = null
                    this.sortType = null
                } else {
                    this.sortType = 'DESC'
                }
            }
            this.$emit('sort', this.sortBy, this.sortType)
        },

        getSortIcon (header) {
            if (header.value !== this.sortBy) {
                return 'custom_sort'
            }

            return this.sortType === 'ASC' ? 'custom_sortASC' : 'custom_sortDESC'
        },

        getHeaderClass (header) {
            const headerClass = []
            if (!this.disableSort && header.sortable !== false) {
                headerClass.push('clickable')
            }
            return headerClass
        },

        getHeaderStyle (header) {
            const style = {
                position: 'sticky',
                top: 0
            }
            if (header.align) {
                style['text-align'] = header.align
            }

            if (header.width) {
                style.width = header.width
                style['min-width'] = header.width
            }

            return style
        }
    }
}
</script>

<style lang="scss" scoped>
.sort-icon {
    top: 35%;
    position: absolute;
}
</style>
